import * as tslib_1 from "tslib";
/* tslint:disable:no-input-prefix */
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, OnChanges, SimpleChange, SimpleChanges, ViewContainerRef } from '@angular/core';
import { BooleanConverter, InputConverter } from '../../../inputConverter';
import { LogLevel } from '../../../types';
import { BaseComponent } from '../../base.component';
var instantiateTimeout = 5;
var WindowComponent = /** @class */ (function (_super) {
    tslib_1.__extends(WindowComponent, _super);
    function WindowComponent(_vcr, LoggingService, cdr, elementRef) {
        var _this = _super.call(this, _vcr) || this;
        _this.LoggingService = LoggingService;
        _this.cdr = cdr;
        _this.elementRef = elementRef;
        _this._disableKeyboard = false;
        _this._height = null;
        _this._isOpened = false;
        _this._minHeight = 100;
        _this._minWidth = 200;
        _this._width = null;
        _this.currentHeight = '100px';
        _this.currentWidth = '200px';
        _this.isInitialized = false;
        _this.isMaximized = false;
        _this.modal = false;
        _this.isResizable = false;
        _this.isDraggable = false;
        _this.isMaximizable = false;
        _this.closable = true;
        _this.maxWidth = null;
        _this.maxHeight = null;
        _this.top = null;
        _this.left = null;
        _this.right = null;
        _this.toggleOpen = false;
        _this.dragEvent = new EventEmitter();
        _this.openChange = new EventEmitter();
        _this.resizeEvent = new EventEmitter();
        _this.stateChange = new EventEmitter();
        _this.close = function () {
            _this.isMaximized = false;
            _this.isOpened = false;
        };
        _this.open = function () {
            _this.isMaximized = false;
            _this.isOpened = true;
        };
        _this.toggle = function (open) { _this.isOpened = open !== undefined ? open : !_this.isOpened; };
        _this.registerEvent('dragEvent', _this.dragEvent);
        _this.registerEvent('openChange', _this.openChange);
        _this.registerEvent('resizeEvent', _this.resizeEvent);
        _this.registerEvent('stateChange', _this.stateChange);
        return _this;
    }
    Object.defineProperty(WindowComponent.prototype, "includeGoogleAnalytics", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowComponent.prototype, "windowRef", {
        get: function () { return this.modal ? this.modalRef : this.popupRef; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowComponent.prototype, "isOpened", {
        get: function () { return this._isOpened; },
        set: function (open) {
            this._isOpened = BooleanConverter(open);
            if (!this._isOpened) {
                this.isInitialized = false;
            }
            this.openChange.emit(open);
            var windowStatus = open ? 'Opened' : 'Closed';
            this.LoggingService.Log("'" + (this.windowTitle || 'Untitled') + "' Window " + windowStatus, this.windowRef, LogLevel.Trace);
            this.cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowComponent.prototype, "disableKeyboard", {
        get: function () { return this._disableKeyboard; },
        set: function (value) {
            this._disableKeyboard = BooleanConverter(value);
            this.setKeyboardShortcuts();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowComponent.prototype, "minWidth", {
        get: function () { return this._minWidth; },
        set: function (value) {
            this._minWidth = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowComponent.prototype, "width", {
        get: function () {
            return this._width === null
                ? ''
                : typeof this._width === 'number' || (typeof this._width === 'string' && this._width.indexOf('px') === -1 && this._width.indexOf('%') === -1)
                    ? this._width + "px"
                    : this._width;
        },
        set: function (value) {
            this._width = typeof value === 'string' ? value.replace('px', '') : value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowComponent.prototype, "minHeight", {
        get: function () { return this._minHeight; },
        set: function (value) {
            this._minHeight = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowComponent.prototype, "height", {
        get: function () {
            return this._height === null
                ? ''
                : typeof this._height === 'number' || (typeof this._width === 'string' && this._width.indexOf('px') === -1 && this._width.indexOf('%') === -1)
                    ? this._height + "px"
                    : this._height;
        },
        set: function (value) {
            this._height = typeof value === 'string' ? value.replace('px', '') : value;
        },
        enumerable: true,
        configurable: true
    });
    WindowComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.isReady();
        this.openChange.subscribe(function (open) {
            if (open) {
                var instantiateInterval_1 = setInterval(function () {
                    if (_this.windowRef) {
                        clearInterval(instantiateInterval_1);
                        if (_this.elementRef.nativeElement.title && !_this.windowTitle) {
                            _this.windowTitle = _this.elementRef.nativeElement.title;
                            _this.elementRef.nativeElement.removeAttribute('title');
                        }
                        _this.setMaxes();
                        _this.setKeyboardShortcuts();
                        _this.setSize();
                        _this.isInitialized = true;
                        _this.cdr.detectChanges();
                    }
                }, instantiateTimeout);
            }
        });
    };
    WindowComponent.prototype.ngOnChanges = function (changes) {
        if (changes.maxWidth || changes.maxHeight || changes.minWidth || changes.minHeight) {
            this.setMaxes();
        }
        if (changes.width || changes.height) {
            this.setSize();
        }
        if (changes.toggleOpen) {
            if (changes.toggleOpen.currentValue) {
                this.open();
            }
        }
    };
    WindowComponent.prototype.setMaxes = function () {
        if (this.windowRef) {
            var windowDiv = this.getWindowDiv();
            if (windowDiv && !this.modal) {
                this.setPopupMaxes(windowDiv);
            }
            else if (windowDiv && this.modal) {
                this.setModalMaxes(windowDiv);
            }
        }
    };
    WindowComponent.prototype.getWindowDiv = function () {
        return this.windowRef ? this.windowRef.nativeElement : null;
    };
    WindowComponent.prototype.setPopupMaxes = function (windowDiv) {
        windowDiv.style.maxHeight = this.maxHeight && this.maxHeight < window.innerHeight ? this.maxHeight + "px" : window.innerHeight + "px";
        windowDiv.style.maxWidth = this.maxWidth && this.maxWidth < window.innerWidth ? this.maxWidth + "px" : window.innerWidth + "px";
        windowDiv.style.minHeight = this.minHeight ? this.minHeight + "px" : null;
        windowDiv.style.minWidth = this.minWidth ? this.minWidth + "px" : null;
        if (this.top) {
            windowDiv.style.top = this.top + "px";
        }
        else {
            var height = this.height && this.height !== '' ? Number(this.height.replace('px', '')) : windowDiv.getBoundingClientRect().height;
            windowDiv.style.top = (window.innerHeight / 2) - (height / 2) + "px";
        }
        if (this.left || this.right) {
            windowDiv.style.left = this.left ? this.left + "px" : windowDiv.style.left;
            windowDiv.style.right = this.right ? this.right + "px" : windowDiv.style.right;
        }
        else {
            var width = this.width && this.width !== '' ? Number(this.width.replace('px', '')) : windowDiv.getBoundingClientRect().width;
            windowDiv.style.left = (window.innerWidth / 2) - (width / 2) + "px";
        }
    };
    WindowComponent.prototype.setModalMaxes = function (windowDiv) {
        windowDiv.style.maxHeight = null;
        windowDiv.style.maxWidth = null;
        if (!this.height) {
            windowDiv.style.maxHeight = '99vh';
        }
        if (!this.width) {
            windowDiv.style.maxWidth = '99vw';
        }
    };
    WindowComponent.prototype.setSize = function () {
        var windowDiv = this.getWindowDiv();
        if (windowDiv) {
            if (this.height) {
                windowDiv.style.height = this.height;
            }
            if (this.width) {
                windowDiv.style.width = this.width;
            }
        }
    };
    WindowComponent.prototype.setKeyboardShortcuts = function () {
        if (this.windowRef) {
            if (this.disableKeyboard) {
                this.windowRef.tabIndex = null;
            }
            else {
                this.windowRef.tabIndex = 0;
            }
            this.cdr.detectChanges();
        }
    };
    WindowComponent.prototype.saveWindowSizeAndLocation = function () {
        var windowDiv = this.getWindowDiv();
        this.height = windowDiv.style.height;
        this.width = windowDiv.style.width;
        if (windowDiv.style.left !== '') {
            this.left = Number(windowDiv.style.left.replace('px', ''));
        }
        if (windowDiv.style.right !== '') {
            this.right = Number(windowDiv.style.right.replace('px', ''));
        }
        if (windowDiv.style.top !== '') {
            this.top = Number(windowDiv.style.top.replace('px', ''));
        }
    };
    WindowComponent.prototype.onDrag = function (mouseDownEvent) {
        var _this = this;
        if (this.isDraggable && !this.isMaximized) {
            mouseDownEvent = mouseDownEvent || window.event;
            mouseDownEvent.preventDefault();
            var position1_1 = 0;
            var position2_1 = 0;
            var position3_1 = mouseDownEvent.clientX;
            var position4_1 = mouseDownEvent.clientY;
            var onMouseMove_1 = function (mouseMoveEvent) {
                mouseMoveEvent = mouseMoveEvent || window.event;
                mouseMoveEvent.preventDefault();
                position1_1 = position3_1 - mouseMoveEvent.clientX;
                position2_1 = position4_1 - mouseMoveEvent.clientY;
                position3_1 = mouseMoveEvent.clientX;
                position4_1 = mouseMoveEvent.clientY;
                var windowDiv = _this.getWindowDiv();
                windowDiv.style.top = (windowDiv.offsetTop - position2_1) + "px";
                windowDiv.style.left = (windowDiv.offsetLeft - position1_1) + "px";
            };
            var onMouseUp_1 = function () {
                document.removeEventListener('mousemove', onMouseMove_1);
                document.removeEventListener('mouseup', onMouseUp_1);
                _this.saveWindowSizeAndLocation();
                var windowDiv = _this.getWindowDiv();
                _this.dragEvent.emit({ left: Number(windowDiv.style.left), top: Number(windowDiv.style.top) });
            };
            document.addEventListener('mousemove', onMouseMove_1);
            document.addEventListener('mouseup', onMouseUp_1);
        }
    };
    WindowComponent.prototype.onMaximize = function () {
        var windowDiv = this.getWindowDiv();
        this.currentHeight = windowDiv.style.height;
        this.currentMaxHeight = windowDiv.style.maxHeight;
        this.currentMaxWidth = windowDiv.style.maxWidth;
        this.currentLeft = windowDiv.style.left;
        this.currentRight = windowDiv.style.right;
        this.currentTop = windowDiv.style.top;
        this.currentWidth = windowDiv.style.width;
        this.isMaximized = true;
        this.cdr.detectChanges();
        windowDiv.style.height = '100vh';
        windowDiv.style.left = '0';
        windowDiv.style.maxHeight = '';
        windowDiv.style.maxWidth = '';
        windowDiv.style.right = '0';
        windowDiv.style.top = '0';
        windowDiv.style.width = '100vw';
        this.stateChange.emit('maximized');
    };
    WindowComponent.prototype.onRestore = function () {
        var windowDiv = this.getWindowDiv();
        windowDiv.style.height = this.currentHeight;
        windowDiv.style.left = this.currentLeft;
        windowDiv.style.maxHeight = this.currentMaxHeight;
        windowDiv.style.maxWidth = this.currentMaxWidth;
        windowDiv.style.right = this.currentRight;
        windowDiv.style.top = this.currentTop;
        windowDiv.style.width = this.currentWidth;
        this.isMaximized = false;
        this.cdr.detectChanges();
        this.stateChange.emit('default');
    };
    WindowComponent.prototype.onResize = function (mouseDownEvent, resizeElement) {
        var _this = this;
        mouseDownEvent = mouseDownEvent || window.event;
        mouseDownEvent.preventDefault();
        var canResizeHeight = resizeElement.id === this.resizeBottomRef.nativeElement.id
            || resizeElement.id === this.resizeBottomLeftRef.nativeElement.id
            || resizeElement.id === this.resizeBottomRightRef.nativeElement.id
            || resizeElement.id === this.resizeTopRef.nativeElement.id
            || resizeElement.id === this.resizeTopLeftRef.nativeElement.id
            || resizeElement.id === this.resizeTopRightRef.nativeElement.id;
        var canResizeWidth = resizeElement.id === this.resizeBottomLeftRef.nativeElement.id
            || resizeElement.id === this.resizeBottomRightRef.nativeElement.id
            || resizeElement.id === this.resizeLeftRef.nativeElement.id
            || resizeElement.id === this.resizeRightRef.nativeElement.id
            || resizeElement.id === this.resizeTopLeftRef.nativeElement.id
            || resizeElement.id === this.resizeTopRightRef.nativeElement.id;
        var resizeEventStart = mouseDownEvent;
        var windowDivStartingSize = this.getWindowDiv().getBoundingClientRect();
        var onMouseMove = function (mouseMoveEvent) {
            mouseMoveEvent = mouseMoveEvent || window.event;
            mouseMoveEvent.preventDefault();
            var windowDiv = _this.getWindowDiv();
            if (canResizeHeight) {
                var adjustTopPosition = resizeElement.id === _this.resizeTopRef.nativeElement.id || resizeElement.id === _this.resizeTopLeftRef.nativeElement.id || resizeElement.id === _this.resizeTopRightRef.nativeElement.id;
                var newHeight = adjustTopPosition
                    ? resizeEventStart.y - mouseMoveEvent.y
                    : mouseMoveEvent.y - resizeEventStart.y;
                var heightAdjustment = windowDivStartingSize.height + newHeight;
                if (heightAdjustment >= _this.minHeight && (!_this.maxHeight || (_this.maxHeight && heightAdjustment <= _this.maxHeight))) {
                    windowDiv.style.height = heightAdjustment + "px";
                    if (adjustTopPosition) {
                        windowDiv.style.top = mouseMoveEvent.y + "px";
                    }
                }
            }
            if (canResizeWidth) {
                var adjustLeftPosition = resizeElement.id === _this.resizeBottomLeftRef.nativeElement.id || resizeElement.id === _this.resizeLeftRef.nativeElement.id || resizeElement.id === _this.resizeTopLeftRef.nativeElement.id;
                var newWidth = adjustLeftPosition
                    ? resizeEventStart.x - mouseMoveEvent.x
                    : mouseMoveEvent.x - resizeEventStart.x;
                var widthAdjustment = windowDivStartingSize.width + newWidth;
                if (widthAdjustment >= _this.minWidth && (!_this.maxWidth || (_this.maxWidth && widthAdjustment <= _this.maxWidth))) {
                    windowDiv.style.width = widthAdjustment + "px";
                    if (adjustLeftPosition) {
                        windowDiv.style.left = mouseMoveEvent.x + "px";
                    }
                }
            }
        };
        var onMouseUp = function () {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            _this.saveWindowSizeAndLocation();
            var windowDiv = _this.getWindowDiv().getBoundingClientRect();
            _this.resizeEvent.emit({ height: windowDiv.height, width: windowDiv.width });
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], WindowComponent.prototype, "modal", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], WindowComponent.prototype, "isResizable", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], WindowComponent.prototype, "isDraggable", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], WindowComponent.prototype, "isMaximizable", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], WindowComponent.prototype, "closable", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number),
        tslib_1.__metadata("design:paramtypes", [Number])
    ], WindowComponent.prototype, "minWidth", null);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], WindowComponent.prototype, "maxWidth", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number),
        tslib_1.__metadata("design:paramtypes", [Number])
    ], WindowComponent.prototype, "minHeight", null);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], WindowComponent.prototype, "maxHeight", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], WindowComponent.prototype, "top", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], WindowComponent.prototype, "left", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], WindowComponent.prototype, "right", void 0);
    return WindowComponent;
}(BaseComponent));
export { WindowComponent };
